import * as _ from 'lodash';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ModelEventTarget } from '../../../event';


/**
 * 配置图表选项的angular组件基类
 * 调用该类实例的configSource方法，可以获得图表的配置源
 */
export abstract class BaseConfigSourceComponent extends ModelEventTarget {
  option: any;
  protected _subject: Subject<any>;

  get config$(): Observable<any> {
    return this._subject.asObservable();
  }

  /**
   * 新建subject对象
   * 导入图表配置信息
   * notes：import方法需要在configSource前调用
   * @param option
   */
  importOption(option) {
    this._subject = new BehaviorSubject(null);
    if (option) {
      this.option = option;
      this._subject.next({
        key: 'option',
        oldValue: option,
        newValue: option,
        option
      });
    }
  }

  exportOption() {
    return _.cloneDeep(this.option);
  }
}
